module.exports = __webpack_public_path__ + "img/district7.16dcd1c9.jpg";